import React, { createContext, ReactNode, useContext } from 'react';

interface IGDLibContext {
  initializeGDLib: (force?: boolean) => Promise<void>;
}

const GDLibContext = createContext<IGDLibContext | undefined>(undefined);

export const GDLibProvider: React.FC<{ children: ReactNode; initializeGDLib: (force?: boolean) => Promise<void> }> = ({
  children,
  initializeGDLib,
}) => {
  return <GDLibContext.Provider value={{ initializeGDLib }}>{children}</GDLibContext.Provider>;
};

export const useGDLibContext = (): IGDLibContext => {
  const context = useContext(GDLibContext);
  if (!context) {
    throw new Error('useGDLibContext must be used within a GDLibProvider');
  }
  return context;
};
